export default "./images/survio-3nVuu-assets-email_answer.png";